import KpiCard from "@/components/KpiCard.vue";
import PercentageValue from "@/components/tableElements/PercentageValue.vue";
import NumberValue from "@/components/tableElements/NumberValue.vue";
import { COLORS } from "@/utils/constants";
import { getDescriptionBasedOnKpiKey } from "@/utils/transformers";
const {
  title,
  detail
} = getDescriptionBasedOnKpiKey("active_asin_count");
export default {
  name: "ListingActiveAsinCard",
  props: {
    amount: {
      type: Number
    },
    percentage: {
      type: Number
    },
    loading: {
      type: Boolean
    }
  },
  components: {
    KpiCard,
    PercentageValue,
    NumberValue
  },
  data() {
    return {
      COLORS,
      title,
      detail
    };
  }
};